<div class="modal-wrapper">
  <div id="attributes-container">
    <ion-grid *ngIf="hasAttributes">
      <ion-row>
        <h5 class="modal-title">Propiedades de los dispositivos</h5>
        <mat-divider></mat-divider>
        <p>Necesitamos que introduzcas las datos de los siguientes sensores:</p>
      </ion-row>
      <form [formGroup]="form" (ngSubmit)="saveAttributes()" #pform="ngForm">
        <ion-row>
          <ng-container formArrayName="attributes">
            <ion-col size="12" *ngFor="let attr of getAttributes().controls; let i = index" [formGroupName]="i">
              <h5>Puerto {{ attr.get('position').value }}</h5>

              <mat-form-field appearance="fill" *ngIf="!isLevelSensor(attr.get('sensorType').value) && !isReservoirLevelSensor(attr.get('sensorType').value)">
                <mat-label>{{ attr.get('name').value }}</mat-label>
                <mat-select formControlName="value" (selectionChange)="selectAttrOption($event, i)">
                  <mat-option *ngFor="let item of options[i]" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <ng-container *ngIf="isPulseCounterSensor(attr.get('sensorType').value) && isPulseCounterEquivalence(attr.get('value').value)">
                <app-pulse-water-register [deviceSensorId]="attr.get('deviceSensorId').value"
                  [commitToken]="commitToken" (changeState)="onPulseAdvancedChange($event)">
                </app-pulse-water-register>
              </ng-container>

              <ng-container *ngIf="isLevelSensor(attr.get('sensorType').value) || isReservoirLevelSensor(attr.get('sensorType').value)">
                <app-level-embalse [deviceSensorId]="attr.get('deviceSensorId').value"
                  [commitToken]="commitToken" (changeState)="onLevelEmbalseChange($event)">
                </app-level-embalse>
              </ng-container>
            </ion-col>

          </ng-container>
        </ion-row>
        <ion-row id="attributes-container-footer">
          <ion-col>
            <button type="submit" mat-raised-button color="primary"
              [disabled]="!form.valid || form.pristine  || isSaving">
              {{ 'general.submit' | translate }}
            </button>
            <button type="button" mat-raised-button (click)="closeModal()" class="me-3" color="warn">Cancelar</button>
          </ion-col>
        </ion-row>
      </form>

    </ion-grid>

    <ion-grid *ngIf="!hasAttributes">
      <ion-row>
        <h5 class="modal-title">Este dispositivo no necesita más información</h5>
      </ion-row>
      <ion-row id="attributes-container-footer">
        <ion-col>
          <button type="button" mat-raised-button (click)="closeModal()" class="me-3" color="warn">Cancelar</button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
